import { FC } from 'react';

import { ComparisonBarItem } from './ComparisonBarChart';
import { TooltipContentProps } from 'recharts';

export const CustomComparisonTooltip: FC<Partial<TooltipContentProps<number, string>>> = ({
  active,
  payload,
}) => {
  if (!active || !payload?.length) return null;

  const { currentName, currentValue, previousName, previousValue } = payload[0]
    .payload as ComparisonBarItem;

  const totalValue = currentValue + previousValue;

  return (
    <div className="bg-white outline outline-custom-warm-grey-200 rounded-[12px] shadow-custom-tooltip min-w-[180px]">
      <div className="text-body-12-semibold text-custom-warm-grey-800 px-3 py-2 border-b border-b-custom-warm-grey-200 flex items-center justify-between">
        <p>Total</p>
        <p>{totalValue}</p>
      </div>
      <div className="flex flex-col gap-2 px-3 py-2 text-custom-warm-grey-700">
        <div className="flex items-center justify-between">
          <p className="text-body-12-regular">{currentName}</p>
          <p className="text-body-12-semibold">{currentValue}</p>
        </div>
        <div className="flex items-center justify-between">
          <p className="text-body-12-regular">{previousName}</p>
          <p className="text-body-12-semibold">{previousValue}</p>
        </div>
      </div>
    </div>
  );
};
